require('./authorizeBizumStep1.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');

//@core
const { formatText } = require('core/i18n').i18n;

//@components
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');
const DropdownAccounts = require('components/dropdownAccounts/dropdownAccounts');

//@utilities
const {getCuentaCorrienteIndexes} = require('utilities/accountTypeHelper.js');

class AuthorizeBizumStep1 extends React.Component {

    render(){
        const {
            phoneNumber,
            onAccountChange,
            immAccounts,
            immStep
        } = this.props;
        const title = formatText("authorizeBizumStep1-title");
        const firstMessage = formatText("authorizeBizumStep1-message1");
        const secondMessage = formatText("authorizeBizumStep1-message2");
        const titleDropdownAccounts = formatText("authorizeBizumStep1-titleDropdownAccounts");
        const titlePhoneNumber = formatText("authorizeBizumStep1-titlePhoneNumber");
        const accountsDropdownError = formatText("authorizeBizumStep1-accountsDropdownError");
        const accountsById = immAccounts.get('byId');
        const accountsIndexes = getCuentaCorrienteIndexes(immAccounts.get('byOrder').toJS(), accountsById);


        return (
            <div className="authorize-bizum-step1">
                <h4 className="wizard-step--vertical__title">{title}</h4>
                <div className="authorize-bizum-step1__content">
                    <div className="authorize-bizum-step1__accounts-dropdown">
                        <BlockInfo extraClass="authorize-bizum-step1__block-info no-print-out">
                            <div>
                                <p>{firstMessage}</p>
                            </div>
                        </BlockInfo>
                        <div className="authorize-bizum-step1__dropdown-container">
                            <p className="authorize-bizum-step1__title-dropdown no-print-out">{titleDropdownAccounts}</p>
                            <DropdownAccounts
                                immAccounts={accountsById}
                                currentAccountId={immStep.get('account')}
                                accountsIndexes={accountsIndexes}
                                onAccountChange={onAccountChange}
                                error={!!immStep.get('error')}
                                errorMsg={accountsDropdownError}
                            />
                        </div>
                    </div>
                    <div className="authorize-bizum-step1__mobile-phone">
                        <BlockInfo extraClass="authorize-bizum-step1__block-info no-print-out">
                            <div>
                                <p>{secondMessage}</p>
                            </div>
                        </BlockInfo>
                        <div className="authorize-bizum-step1__phone-container">
                            <p className="authorize-bizum-step1__title-phone-number">{titlePhoneNumber}</p>
                            <p className="authorize-bizum-step1__phone-number">{phoneNumber}</p>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

AuthorizeBizumStep1.propTypes = {
    immStep: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    phoneNumber: PropTypes.string.isRequired,
    onAccountChange: PropTypes.func.isRequired,
}

module.exports = AuthorizeBizumStep1;
